import React from 'react';
import { NavigationDropdownMode } from '../../Navigation.types';
import NavigationDropdown from '../NavigationDropdown/NavigationDropdown';
import S from './NavigationItem.styles';
const NavigationItem = ({ children, dropdown = NavigationDropdownMode.None, id, openNav, promo, selected, setOpenNav, text, url, }) => {
    const hasDropdown = dropdown !== NavigationDropdownMode.None;
    return (React.createElement(S.Item, { onKeyDown: (event) => {
            if (event.key.toLowerCase() === 'escape') {
                event.preventDefault();
                event.stopPropagation();
                setOpenNav('');
                return;
            }
        } },
        React.createElement(S.Link, { onClick: (event) => {
                // If the item has no drop down then let the link behave normally.
                if (!hasDropdown) {
                    return;
                }
                event.preventDefault();
                if (id && id !== openNav) {
                    setOpenNav(id);
                }
                else {
                    setOpenNav('');
                }
            }, href: url, isActive: openNav == id },
            React.createElement(S.LinkInternal, null,
                React.createElement(S.LinkText, null, text),
                hasDropdown && (React.createElement(S.Chevron, null)))),
        hasDropdown && (React.createElement(NavigationDropdown, { isActive: openNav === id, areaTitle: text, areaUrl: url, items: children, selected: selected, mode: dropdown, promo: promo }))));
};
export default NavigationItem;
